module.exports = __webpack_public_path__ + "img/SLA.35349b0.webp";